import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../../routes';
import { EPurchaseRoutes } from '../../../../purchase.routes';
import { EOrderSettingsRoutes } from '../../orderSettings.routes';
import { Container, ButtonContainer } from './styles';
import { Button, Modal } from '@gerdau/hefesto';
import { useDispatch, useSelector } from 'react-redux';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { ApplicationState } from '../../../../../../store';

interface FooterButtonContainerProps {
  customStyle?: React.CSSProperties;
  itensQuantity: number;
  onConfirmClick(): void;
  totalQuantity?: string;
  notFoundItems?: number;
  disabledConfirmButton?: boolean;
  isShoppingCartFloatBar?: boolean;
  numberMaxOfItens?: number;
}

const FooterButtonContainer: React.FC<FooterButtonContainerProps> = ({
  itensQuantity,
  notFoundItems,
  onConfirmClick,
  disabledConfirmButton = false,
  numberMaxOfItens
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalContentMessage = notFoundItems
    ? `O${notFoundItems > 1 ? 's' : ''} ${
        notFoundItems > 1 ? notFoundItems : ''
      } ite${notFoundItems > 1 ? 'ns' : 'm'} 
            que não fo${notFoundItems > 1 ? 'ram' : 'i'} identificado${
        notFoundItems > 1 ? 's' : ''
      } não ser${notFoundItems > 1 ? 'ão' : 'á'} 
            adicionado${notFoundItems > 1 ? 's' : ''}  ao carrinho.`
    : '';

  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const orderItemSearch = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch
  );

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    document.location.pathname
  );

  const onConfirm = () =>
    notFoundItems && notFoundItems > 0
      ? setIsModalOpen(true)
      : onConfirmClick();

  const handleTitleAdvanceButtonTagging =
    document.location.pathname === '/purchase/long-steel/repeat-order'
      ? 'continuarPedidoSelecionado'
      : document.location.pathname === '/purchase/long-steel/spreadsheet-upload'
      ? 'enviarPlanilhaContinuar'
      : document.location.pathname === '/purchase/long-steel/search-items' &&
        'avancar_detalhamento';

  const getButtonLabel = (pathName: string): string => {
    const labels: { [key: string]: string } = {
      '/purchase/long-steel/repeat-order': 'Continuar com o pedido selecionado',
      '/purchase/long-steel/spreadsheet-upload': 'Enviar planilha e continuar',
      '/purchase/long-steel/search-items': 'Avançar para o detalhamento'
    };

    return labels[pathName] ?? 'Avançar';
  };

  return (
    <Container>
      {isModalOpen && (
        <Modal
          title="Atenção"
          modalSize="sm"
          onClose={() => setIsModalOpen(false)}
          buttons={{
            left: {
              children: 'Voltar e revisar',
              name: 'voltar-e-revisar',
              onClick: () => setIsModalOpen(false),
              type: 'button'
            },
            right: {
              children: 'Concordar e prosseguir',
              name: 'concordar-e-prosseguir',
              onClick: onConfirmClick,
              type: 'button'
            }
          }}
        >
          {modalContentMessage}
        </Modal>
      )}
      <ButtonContainer>
        <Button
          type="button"
          name="searchBack"
          variant="secondary"
          labelPosition="center"
          onClick={() => {
            dispatch(
              sendTagging({
                screenName,
                event: 'click',
                itemName: 'button:cancelarVoltar',
                itemDescription: `${itemDescription}_cancelarVoltar`,
                filterInfo: `#codEmr:${
                  shoppingCartState.emitterId
                    ? shoppingCartState.emitterId
                    : 'not_set'
                }#codRbd:${
                  shoppingCartState.receiverId
                    ? shoppingCartState.receiverId
                    : 'not_set'
                }#tpCod:not_set#flt:not_set`,
                orderCliente: shoppingCartState.customerOrder
                  ? shoppingCartState.customerOrder
                  : 'not_set'
              })
            );

            history.push(
              `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${EOrderSettingsRoutes.ENTRY_TYPE}`
            );
          }}
        >
          Cancelar e voltar
        </Button>
        <Button
          type="button"
          name="searchAdvance"
          variant="primary"
          labelPosition="center"
          loading={orderItemSearch.searchingItems}
          onClick={() => {
            dispatch(
              sendTagging({
                screenName,
                event: 'click',
                itemName: `button:${handleTitleAdvanceButtonTagging}`,
                itemDescription: `${itemDescription}_${handleTitleAdvanceButtonTagging}`,
                filterInfo: `#codEmr:${
                  shoppingCartState.emitterId
                    ? shoppingCartState.emitterId
                    : 'not_set'
                }#codRbd:${
                  shoppingCartState.receiverId
                    ? shoppingCartState.receiverId
                    : 'not_set'
                }#tpCod:not_set#flt:not_set`,
                orderCliente: shoppingCartState.customerOrder
                  ? shoppingCartState.customerOrder
                  : 'not_set'
              })
            );

            onConfirm();
          }}
          disabled={
            disabledConfirmButton ||
            (numberMaxOfItens !== undefined && itensQuantity > numberMaxOfItens)
          }
        >
          {!orderItemSearch.searchingItems &&
            getButtonLabel(document.location.pathname)}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default FooterButtonContainer;
